module.exports = __webpack_public_path__ + "static/media/ic_hospicash_b3_myway.0c6b01ae.svg";